import { makeRequest } from "./index";

export async function getUnities() {
  return await makeRequest("GET", "/unities");
}

export async function getSimpleUnities() {
  return await makeRequest("GET", "/unities/get/baseInfo");
}

export async function getUnitiesWithFilters(filters) {
  return await makeRequest("GET", "/unities", null, filters);
}

export async function getUnitiesDetails(unityId) {
  return await makeRequest("GET", `/unities/${unityId}`);
}

export async function createUnity(unity) {
  return await makeRequest("POST", "unities", unity);
}

export async function updateUnity(id, unity) {
  return await makeRequest("PUT", `/unities/${id}`, unity);
}

export async function getAdministrativeSphere() {
  return await makeRequest("GET", "/administrative_spheres");
}

export async function getNatureOrganization() {
  return await makeRequest("GET", "/nature_organizations");
}

export async function getTypeUnities() {
  return await makeRequest("GET", "/type_unities");
}

export async function getAccreditationLevel() {
  return await makeRequest("GET", "/accreditations");
}

export async function bindCoverageUnity(unityId, coverages) {
  return await makeRequest("POST", `/unities/${unityId}/coverage`, coverages);
}

export async function getGroupsProcedures() {
  return await makeRequest("GET", "/group_procedures");
}

export async function getGroupProceduresDetails(id) {
  return await makeRequest("GET", `/group_procedures/${id}`);
}

export async function getProceduresTypes() {
  return await makeRequest("GET", "/procedure_types");
}

export async function getProceduresByUnity(unityId) {
  return await makeRequest(
    "GET",
    `/unities/${unityId}/getProcedureTypeToUnity`
  );
}

export async function bindProceduresInUnity(unityId, procedures) {
  return await makeRequest("POST", `/unities/${unityId}/ppp_image`, procedures);
}

export async function bindProceduresOccupationInUnity(unityId, procedure) {
  return await makeRequest(
    "POST",
    `/unities/link_occupation/${unityId}`,
    procedure
  );
}

export async function unbindProceduresOccupationInUnity(procedureId) {
  return await makeRequest(
    "DELETE",
    `/unities/remove_link_occupation/${procedureId}`
  );
}

export async function bindEgressProceduresOccupationInUnity(
  unityId,
  procedure
) {
  return await makeRequest(
    "POST",
    `/unities/link/occupation_egress/${unityId}`,
    procedure
  );
}

export async function bindOncologyProceduresOccupationInUnity(
  unityId,
  procedure
) {
  return await makeRequest(
    "POST",
    `/unities/link/occupation_oncology/${unityId}`,
    procedure
  );
}

export async function bindOcupationProceduresEletiveInUnity(
  unityId,
  procedure
) {
  return await makeRequest(
    "POST",
    `/unities/link/occupation_eletive/${unityId}`,
    procedure
  );
}

export async function unbindOcupationProceduresEletiveInUnity(
  unityId,
  procedure
) {
  return await makeRequest(
    "DELETE",
    `/unities/remove/link_occupation_eletive/${unityId}`,
    procedure
  );
}

export async function unbindEgressProceduresOccupationInUnity(procedureId) {
  return await makeRequest(
    "DELETE",
    `/unities/remove/link_occupation_egress/${procedureId}`
  );
}

export async function unbindOncologyProceduresOccupationInUnity(procedureId) {
  return await makeRequest(
    "DELETE",
    `/unities/remove/link_occupation_oncology/${procedureId}`
  );
}

export async function linkProfessionalOnUnity(id, data) {
  return await makeRequest("POST", `unities/link_Professionals/${id}`, data);
}

export async function bindDistricts(unityId, data) {
  return await makeRequest("POST", `unities/${unityId}/districts`, data);
}

export async function linksExclusivityToProcedure(procedure, unities) {
  let route;

  switch (procedure.route) {
    case "outpatient":
      route = "ambulatoryResevedProcedures";
      break;

    case "ppp":
      route = "pppImageResevedProcedures";
      break;

    case "egress":
      route = "egressResevedProcedures";
      break;

    case "unacon":
      route = "oncologyResevedProcedures";
      break;

    default:
      break;
  }

  return await makeRequest(
    "POST",
    `unity_ocupation_procedures/${route}/${procedure.id}`,
    unities
  );
}

export async function getNoDetailsUnitiesByType(typeId) {
  return await makeRequest("GET", `unities/type_unity/${typeId}`);
}

export async function saveProceduresOccupationReferenceInUnity(
  procedureId,
  data
) {
  return await makeRequest(
    "PATCH",
    `unity_ocupation_procedures/updateIsReference/${procedureId}`,
    data
  );
}
